// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__2LLck","detailsBorder":"styles_detailsBorder__AJU2U"};